const TitleH5 = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => {
  return (
    <h5 className={`text-primary text-xl font-normal ${className}`}>{title}</h5>
  );
};

export default TitleH5;
